import Cookie from "js-cookie";
import store from "../../store";
import urlPermissionMap from "@/config/urlPermissionMap.json";

export default async function auth({ to, next }) {
  const token = Cookie.get("ecs_admin_jwt_token") || null;
  const tokenStore = store.getters["auth/token"];
  const requiredsAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiredsAuth) {
    if (!token && !tokenStore) {
      next({ name: "Login" });
    } else if (token && tokenStore) {
      await store.dispatch("commons/getCommonsData");
      await store
        .dispatch("auth/accountInfo")
        .then(() => {
          let dataPermissionCanAccess =
            store.getters["auth/account"].permissions;
          let routerName = urlPermissionMap[to.name];
          if (to.name == "HomePage") {
            let routerDashboard = urlPermissionMap["dashboard"];
            if (!dataPermissionCanAccess.includes(routerDashboard)) {
              next({ name: "AdminDefault" });
            } else {
              next({ name: "dashboard" });
            }
          }
          if (
            routerName !== undefined &&
            routerName !== "HomePage" &&
            !dataPermissionCanAccess.includes(routerName)
          ) {
            next({ name: "403" });
          }
        })
        .catch(() => {});
    }
    next();
  } else {
    if (to.name === "Login" && token && tokenStore) {
      let routerName = urlPermissionMap["dashboard"];
      let dataPermissionCanAccess =
        store.getters["auth/account"].permissions || [];
      if (dataPermissionCanAccess.includes(routerName)) {
        next({ name: "dashboard" });
      } else {
        next({ name: "AdminDefault" });
      }
    }
    next();
  }
}
